/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { CommonInput, Loader } from 'pg-ui-library';

import { DetailsWrapper } from './styles';

interface IDetails {
  totalEmployees: string;
  totalCost: string;
  totalHours: string;
  directDeposits: string;
  paperChecks: string;
}

const PayHistoryDetails: React.FC<{
  data: IDetails | undefined;
  isLoading: boolean;
}> = ({ data, isLoading }) => {
  if (isLoading) {
    return <Loader />;
  }
  return (
    <DetailsWrapper>
      <CommonInput disabled label="Total Employees" value={data?.totalEmployees} />

      <CommonInput disabled label="Total Cost" value={data?.totalCost} />

      <CommonInput disabled label="Total Hours" value={data?.totalHours} />

      <CommonInput disabled label="Direct Deposits" value={data?.directDeposits} />

      <CommonInput disabled label="Paper Checks" value={data?.paperChecks} />
    </DetailsWrapper>
  );
};

export default PayHistoryDetails;
